import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MenuBar from "./MenuBar";
import Footer from "./Footer";
import WeeklyScheduleModal from "./WeeklyScheduleModal";
import { Button, TextField, Grid, Container, Typography } from "@mui/material";
import "./Style.css";
const envVariable = require("../EnvironmentVariables.json");

function UpdateEmployee() {
  const { id } = useParams();
  const navigate = useNavigate();
  const SC_Id = localStorage.getItem("SC_Id");
  const [formErrors, setFormErrors] = useState({});
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [employeeRole, setEmployeeRole] = useState("");
  const [formData, setFormData] = useState({
    employeeId: "",
    firstName: "",
    lastName: "",
    email: "",
    skill: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zipCode: "",
    contactNumber: "",
    country: "",
  });

  const fetchEmployeeRole = async (userId) => {
    try {
      const response = await fetch(
        `${envVariable.serverId}/SCO/getEmployeeRole.php?user_id=${userId}&sc_id=${SC_Id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (data.status === "success" && data.role) {
        setEmployeeRole(data.role);
      }
    } catch (error) {
      console.error("Error fetching employee role:", error);
    }
  };

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await fetch(envVariable.serverId + `/SCO/UpdateEmployee.php?id=${id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        if (data.status === "success") {
          setFormData({
            ...formData,
            employeeId: data.data.user_id,
            firstName: data.data.first_name,
            lastName: data.data.last_name,
            email: data.data.email,
            skill: data.data.skills,
            addressLine1: data.data.address1,
            addressLine2: data.data.address2,
            city: data.data.city,
            state: data.data.state,
            zipCode: data.data.zipcode,
            contactNumber: data.data.phone,
            country: data.data.country,
          });
          // Fetch employee role from user_roles table
          fetchEmployeeRole(data.data.user_id);
        } else {
          console.error(data.message);
        }
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };

    fetchEmployeeData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const errors = {};
    const fields = [
      "firstName",
      "lastName",
      "email",
      "skill",
      "addressLine1",
      "city",
      "state",
      "zipCode",
      "contactNumber",
      "country",
    ];

    fields.forEach((field) => {
      if (typeof formData[field] === "string" && !formData[field].trim()) {
        errors[field] = `${field} is required`;
      } else if (field === "email" && !/^\S+@\S+\.\S+$/.test(formData.email)) {
        errors.email = "Invalid email format";
      } else if (field === "contactNumber" && !/^\d{10}$/.test(formData.contactNumber)) {
        errors.contactNumber = "Invalid phone number, must be 10 digits";
      } else if (field === "zipCode" && !/^\d{5}$/.test(formData.zipCode)) {
        errors.zipCode = "Invalid zip code, must be 5 digits";
      }
    });

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await fetch(envVariable.serverId + "/SCO/UpdateEmployee.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...formData, id }),
      });
      const data = await response.json();
      if (data.status === "success") {
        navigate("/employees");
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleCancel = () => {
    navigate("/employees");
  };

  return (
    <>
      <MenuBar />
      <Container maxWidth="md" style={{ marginTop: "20px" }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Update Employee
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="First Name"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                error={!!formErrors.firstName}
                helperText={formErrors.firstName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                error={!!formErrors.lastName}
                helperText={formErrors.lastName}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                error={!!formErrors.email}
                helperText={formErrors.email}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Skill"
                name="skill"
                value={formData.skill}
                onChange={handleChange}
                error={!!formErrors.skill}
                helperText={formErrors.skill}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address Line 1"
                name="addressLine1"
                value={formData.addressLine1}
                onChange={handleChange}
                error={!!formErrors.addressLine1}
                helperText={formErrors.addressLine1}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address Line 2"
                name="addressLine2"
                value={formData.addressLine2}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                error={!!formErrors.city}
                helperText={formErrors.city}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="State"
                name="state"
                value={formData.state}
                onChange={handleChange}
                error={!!formErrors.state}
                helperText={formErrors.state}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Zip Code"
                name="zipCode"
                value={formData.zipCode}
                onChange={handleChange}
                error={!!formErrors.zipCode}
                helperText={formErrors.zipCode}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Contact Number"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleChange}
                error={!!formErrors.contactNumber}
                helperText={formErrors.contactNumber}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Country"
                name="country"
                value={formData.country}
                onChange={handleChange}
                error={!!formErrors.country}
                helperText={formErrors.country}
              />
            </Grid>
          </Grid>

          <Grid container justifyContent="center" spacing={2} style={{ marginTop: "20px" }}>
            <Grid item>
              <Button variant="contained" sx={{ backgroundColor: "grey.500", color: "white" }} onClick={handleCancel}>
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" color="primary" type="submit">
                Update Employee
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: employeeRole === 'Mechanic' ? '#4CAF50' : '#cccccc',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: employeeRole === 'Mechanic' ? '#45a049' : '#cccccc',
                  },
                  cursor: employeeRole === 'Mechanic' ? 'pointer' : 'not-allowed',
                  opacity: employeeRole === 'Mechanic' ? 1 : 0.6
                }}
                onClick={() => employeeRole === 'Mechanic' && setScheduleModalOpen(true)}
                disabled={employeeRole !== 'Mechanic'}
                title={employeeRole !== 'Mechanic' ? 'Weekly schedule is only available for mechanics' : ''}
              >
                Weekly Schedule
              </Button>
            </Grid>
          </Grid>
        </form>
      </Container>
      <WeeklyScheduleModal
        open={scheduleModalOpen}
        onClose={() => setScheduleModalOpen(false)}
        mechanic={{
          user_id: formData.employeeId,
          first_name: formData.firstName,
          last_name: formData.lastName
        }}
        scId={SC_Id}
      />
      <Footer />
    </>
  );
}

export default UpdateEmployee;
